import { BookingDraftStatus } from '@dc-trans/data-layer';

export const getStatusAttr = (status: string) => {
  let color;
  switch (status) {
    case 'new':
      color = 'blue';
      break;
    case 'waiting_shipment':
      color = 'orange';
      break;
    case 'completed':
      color = 'green';
      break;
    case 'confirmation_failed':
    case 'canceled':
    case 'expired':
      color = 'error';
      break;
    default:
      color = 'default';
      break;
  }

  return {
    color,
    label: BookingDraftStatus[status as keyof typeof BookingDraftStatus],
  };
};
